import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';

import { JMETER_SDK_PROVIDER } from './core/services/jmeter-sdk.provider';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // Loads assets/config.json, then hands the injector to ngx-auth, which runs the SSO sign-in
    // (redirecting to the IdP if there is no session) before the app bootstraps. ngx-auth's own
    // providers — HttpClient with its token interceptor, the OAuth client, the /auth callback
    // routes — ride along inside this configuration, so nothing auth-related is registered twice.
    //
    // Nothing else may provide CONFIG_MANAGER_SERVICE_CONFIGURATION. In particular, do not
    // `importProvidersFrom(DataApiModule)`: that module registers its own bare configuration for the
    // same token, and as the later provider it silently replaces this one — config.json still loads,
    // but the afterInitialization hook that starts SSO is gone, and the app sits on the
    // "Authenticating…" splash forever.
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration({
        firebaseOptions: environment.firebase,
        configFileUrl: './assets/config.json',
      })
    ),
    JMETER_SDK_PROVIDER,
    provideBrowserGlobalErrorListeners(),
    // Route parameters (:component, :result) arrive as component inputs.
    provideRouter(routes, withComponentInputBinding()),
  ],
};
